const LABEL_KEYS = Object.freeze({
    what: 'search_panel.labels.what',
    when: 'search_panel.labels.when',
    where: 'search_panel.labels.where',
    category: 'search_panel.labels.category',
});

const PLACEHOLDER_KEYS = Object.freeze({
    what: 'search_panel.placeholders.what',
    when: 'search_panel.placeholders.when',
    where: 'search_panel.placeholders.where',
    category: 'search_panel.placeholders.category',
});

const SUBMIT_KEY = 'search_panel.submit';
const CLEAR_ALL_KEY = 'search_panel.clear_all';

export {
    LABEL_KEYS, PLACEHOLDER_KEYS, SUBMIT_KEY, CLEAR_ALL_KEY,
};
